<template>
  <div class="Input">
    <input v-if="type=='password'" name="hiddenPwd" type="password" style="opacity: 0; height: 0" :autocomplete="autoCom">
    <input :class="className" :type="type" :maxlength="maxl" :minlength="minl" :disabled="disabled" :readonly="readonly"
     ref="input" :unselectable="readonly?'on':''" v-bind:value="value" v-on:input="updateValue($event.target.value)"
      @keyup.enter="onEnter" v-bind:id="inputId" @focus="onFocus" @blur="onBlur" :autocomplete="autoCom"/>
    <label v-show="showMsg" v-bind:for="inputId" class="holder" @click="dispear" >{{msg}}</label>
  </div>
</template>

<script>
import {validateUtil} from '../common/ValidateUtil.js';
import {CommonUtil} from '../common/CommonUtil.js';
import {replaceUtil} from '../common/ReplaceUtil.js';

export default {
  name: 'Input',
  mounted () { //设置title
      this.msg = this.tipMsg;
      //密码栏默认不自动填充密码
      if(this.type=='password'){
        if(this.autocomplete!=null && this.autocomplete!=undefined){
          if(this.autocomplete=='off' && CommonUtil.isChrome()){
            this.autoCom='new-password';
          }else{
            this.autoCom=this.autocomplete;
          }
        }else{
          if(CommonUtil.isChrome()){
            this.autoCom='new-password';
          }else{
            this.autoCom='off';
          }
        }
      }else{
        //非密码栏默认自动填充密码
        if(this.autocomplete!=null && this.autocomplete!=undefined){
          if(this.autocomplete=='off' && CommonUtil.isChrome()){
            this.autoCom='new-password';
          }else{
            this.autoCom=this.autocomplete;
          }
        }
      }
  },
  data: function(){
    return {
      autoCom:'on',
      onOff: true,
      msg: null,
      inputId: CommonUtil.getUuid()
    }
  },
  props: ['type','className','maxl','minl','value','rules', 'tipMsg', 'disabled','readonly', 'replace','autocomplete'],
  methods:{
    updateValue: function(val){
      var result = val.trim();
      if (result !== val) {
        this.$refs.input.value = result
      }
      if(this.replace!=null){
          var newVal=replaceUtil.replace(this.replace,result);
          if(this.$refs.input.value!=newVal){
            this.$refs.input.value = newVal;
          }
          result = newVal;
      }
      if(this.maxl!=null && result.length>this.maxl){
        result=result.substring(0,this.maxl);
        this.$refs.input.value = result;
      }
      this.msg = this.tipMsg;  //重置msg为tipmsg
      this.$emit('input', result);
      if(this.value ==  '' && !this.disabled) {
        this.onOff = true;
      }
    },
    onEnter: function (event) {
      //validate
      this.onOff = true
      var result = validateUtil.validate(this.rules,this.$refs.input.value);
      if(result != null){ //验证出错，则清空input值，并设置错误信息
        this.msg = result;
        this.value = '';
        this.$emit('input', '');
        setTimeout(()=>{
          if(this.tipMsg!=null && this.tipMsg!=undefined){
            this.msg=this.tipMsg;
          }else{
            this.msg='';
          }
        },2000);
      }else{ //验证通过，则根据规则focus表单下一元素
        //call parent event
        this.$emit('enter'); //触发父组件事件，并把父组件ref回传
      }
    },
    limit: function(ev) {
      if(this.writeLimit) {
      }
    },
    dispear: function () {
      if( !this.disabled ) {
        this.onOff = false
        this.$refs.input.focus()
      }
    },
    onBlur: function () {
      if( !this.disabled && this.value == '' ) {
        this.onOff = true
      }
    },
    onFocus: function(){
      this.$refs.input.select();
    },
    focus: function (){
      this.$refs.input.focus();
    },
    //显示错误消息(参数:错误提示,是否焦点定位到错误提示栏,提示语超时时长,提示语超时后重置的提示语,是否永远显示错误提示)
    showError: function (msg,isFocus,timeout,timeoutMsg,alwaysShowMsg) {
      if(msg === null){
        return;
      }

      this.$emit('input', '');
      this.onOff = true;
      this.msg = msg;
      if(isFocus==null || isFocus==undefined || isFocus==true){//设置提示语后是否焦点定位到该元素焦点,不传或传true表示要定位到焦点
        setTimeout(()=>{
          this.focus();
        },500);
      }
      if(alwaysShowMsg==null || alwaysShowMsg==undefined || alwaysShowMsg==false){
        var t=2000;
        if(timeout!=null && timeout!=undefined && timeout>0){//提示语显示的时候,超出时间后重置为指定提示语
          t=timeout;
        }
        setTimeout(()=>{
          if(timeoutMsg!=null && timeoutMsg!=undefined){
            this.msg = timeoutMsg;
          }else{
            if(this.tipMsg!=null && this.tipMsg!=undefined){
              this.msg=this.tipMsg;
            }else{
              this.msg='';
            }
          }
        },t);
      }
    },
    getInput: function(){
      return this.$refs.input;
    },
    getProps: function(){
      var result = {};
      result.required = false;
      if(this.rules!=null && this.rules!=undefined){
        for(var i=0; i< this.rules.length; i++){
          if(this.rules[i].name == 'required'){
            result.required = true;
            break;
          }
        }
      }
      result.value = this.value;
      return result;
    }
  },
  computed:{
    showMsg: function(){
      return ( this.onOff && this.msg != null && this.value == '')
    }
  }
}
</script>
<style scoped>
 .Input{
  width:100%;
  height:100%;
  position:relative;
  top:-1px;
  left:-1px;
 }
 /*IE下禁用中文输入法*/
 .ime{
   ime-mode:disabled
 }
 .Input input {
   position:absolute;
   box-sizing:border-box;
   top:1px;
   left:1px;
   width:100%;
   height:100%;
   border:1px solid #d2d2d2;
   font-size: 16px;
   text-indent: 1px;
  }
  .pageBorder {
    border: 1px solid #a4a4a4;
  }
 .holder {
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing:border-box;
  color: #afafaf;
  font-size: 16px;
  font-weight:500;
  line-height:46px;
  text-align: center;
  outline: none;
  position:absolute;
  top:1px;
  left:1px;
  display:inline-block;
  cursor:text;
  user-select:none;
  -ms-user-select: none;
}
.pr30 {
  padding-right: 30px;
}
.pr30~label {
}
.yzmcss{
  padding-right:84px;
  box-sizing:border-box;
}
.yzmcss~label{
  padding-right:84px;
  box-sizing:border-box;
  font-size: 22px!important
}
.Input .noBorder {
  border:none;
}
input.table {
  background:rgb(247, 223, 173);
}
input[readonly="readonly"]{
  background: #fff;
}
.input:disabled {
  background: #fff!important;
}
input:disabled{
  background: #efefef!important;
}
input[type='text']::-ms-clear {
  display: none;
}
input[type='password']::-ms-reveal {
  display: none;
}
.textCenter input {
  text-align: center;
}
.textLeft .holder {
  font-size: 14px;
  text-indent: 12px;
  line-height: 43px;
  text-align: left;
  color: #999;
}
 .textLeft input {
   text-indent: 12px!important;
   color: #333!important;
 }
</style>
